import React from 'react';
import { connect } from 'react-redux'
import NuevaSolicitud from './NuevaSolicitud.js';

//Importación de actions.
import
{
    getScreenData,
    addTarjeta,
    changeResponsable,
    changeDomicilio,
    removeTarjeta,
    guardarSolicitud,
    showError,
    changeLimite,
    changeProductoIbs,
    reiniciarEstado,
    preGuardarSolicitud
} from '../actions/Actions.js';


const mapStateToProps = (state) => {
  return {
      data: state.nuevaSolicitudDelivery,
      plasticos: state.tarjetas,
      login: state.menuProductos.login
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
      getScreenData: (state, currentScope, nroCuenta, poseeTarjetas, login) => {
          dispatch(getScreenData(state, currentScope, nroCuenta, poseeTarjetas, login));
      },
      addTarjeta: (tarjeta) => {
          dispatch(addTarjeta(tarjeta));
      },
      changeResponsable: (responsable) => {
          dispatch(changeResponsable(responsable));
      },
      changeDomicilio: (domicilio) => {
          dispatch(changeDomicilio(domicilio));
      },
      removeTarjeta: (tarjeta) => {
          dispatch(removeTarjeta(tarjeta));
      },
      showError: (esError) => {
          dispatch(showError(esError));
      },
      changeLimite: (idLimite) => {
          dispatch(changeLimite(idLimite));
      },
      changeProductoIbs: (idProductoIbs) => {
          dispatch(changeProductoIbs(idProductoIbs));
      },
      reiniciarEstado: () => {
          dispatch(reiniciarEstado());
      },
      preGuardarSolicitud: (tarjetas, clienteActual, data, estadoPlastico) => {
          dispatch(preGuardarSolicitud(tarjetas, clienteActual, data, estadoPlastico));
      }
  }
}

//Connect entre el componente y las props y actions.
const NuevaSolicitudContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitud);

export default NuevaSolicitudContainer;